var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.544922,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.6767C8 18.3245 12.2445 22.168 14.1232 23.6416C14.3921 23.8525 14.5281 23.9592 14.7287 24.0133C14.8849 24.0555 15.1148 24.0555 15.271 24.0133C15.472 23.9591 15.6071 23.8535 15.877 23.6418C17.7557 22.1682 22 18.3249 22 13.6771C22 11.9182 21.2625 10.2311 19.9498 8.98738C18.637 7.74364 16.8566 7.04492 15.0001 7.04492C13.1436 7.04492 11.363 7.74375 10.0503 8.98748C8.7375 10.2312 8 11.9178 8 13.6767Z",
    stroke: "#151515",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.7926C13 13.8507 13.8955 14.7085 15 14.7085C16.1046 14.7085 17.0001 13.8507 17.0001 12.7926C17.0001 11.7345 16.1046 10.8767 15 10.8767C13.8955 10.8767 13 11.7345 13 12.7926Z",
    stroke: "#151515",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon2);
export default __webpack_public_path__ + "static/media/location-icon-2.0068afe427dcc12fee63da08bf86f48c.svg";
export { ForwardRef as ReactComponent };